<template>
  <header
    :class="[
      'header-area bg-white text-center text-md-start pt-15 pb-15 ps-15 pe-15 ps-md-20 pe-md-20 pe-lg-30 transition mb-25 position-fixed',
      { sticky: isSticky },
    ]"
    id="header"
    v-if="stateStoreInstance.show == true"
  >
    <div class="row align-items-center">
      <div class="col-xl-4 col-lg-5 col-md-6">
        <div
          class="header-left-side justify-content-center justify-content-md-start d-flex align-items-center"
        >
          <button
            class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0"
            id="header-burger-menu"
            @click="stateStoreInstance.onChange"
          >
            <i class="flaticon-menu-3"></i>
          </button>
          <button @click="getFile" class="header-burger-menu transition position-relative lh-1 bg-transparent p-0 border-0">
            <i class="flaticon-idea"></i>
          </button>
        </div>
      </div>
      <div class="col-xl-8 col-lg-7 col-md-6">
        <div
          class="header-right-side d-flex align-items-center flex-nowrap justify-content-center justify-content-md-end"
        >

          <div class="dropdown profile-dropdown balance-item d-flex align-items-center">
            <button
              @click="toggleBalancesModal"
              class="dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
              type="button"
              :aria-expanded="showBalancesModal"
            >
              <div class="icon text-primary rounded-circle text-center balance-icon" style="border:1px solid blueviolet;">
                <i class="flaticon-money fs-2x"></i>
              </div>
              <span class="title balance-title ms-10 ms-lg-15">
                <span class="d-block fw-bold mb-5 mb-md-8">{{ mainBalance }} XOF</span>
                <span class="text-body-emphasis fw-semibold fs-13 balance-label">{{ $t('header.mainBalance') }}</span>
              </span>
              <span class="balance-chevron ms-6" :class="{ 'is-open': showBalancesModal }">
                <i :class="showBalancesModal ? 'ph-bold ph-caret-up' : 'ph-bold ph-caret-down'"></i>
              </span>
            </button>
          </div>

          <div class="dropdown email-dropdown"></div>
          <div class="dropdown profile-dropdown">
            <router-link
              to="/account-settings"
              class="forgot-password-btn fs-md-15 fs-lg-16 text-decoration-none position-relative text-primary"
            >
              <button
                class="dropdown-toggle text-start fs-14 text-black-emphasis d-flex align-items-center p-0 position-relative bg-transparent border-0 transition lh-1"
                type="button"
                aria-expanded="false"
              >
                <img
                  src="../../assets/images/admin.jpg"
                  class="rounded flex-shrink-0"
                  width="44"
                  height="44"
                  alt="admin"
                />
                <span class="title d-none d-lg-block ms-10 ms-lg-15 user-info">
                  <span class="d-block fw-bold mb-5 mb-md-8 text-truncate" style="font-size: 12px;">{{ organizationName }}</span>
                  <span class="text-body-emphasis fw-semibold fs-13"></span>
                  <span class="d-block text-body-emphasis fw-semibold fs-13 text-truncate" :title="userEmail">{{ userEmail }}</span>
                  <span class="d-block mb-5 mb-md-8" style="font-size: 10px;font-style: italic;">{{ userRole }}</span>
                </span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </header>

  <!-- === MODAL AUTRES SOLDES === -->
  <teleport to="body">
    <div v-if="showBalancesModal" class="balances-modal-overlay" @click.self="closeBalancesModal">
      <div class="balances-modal-content">
        <div class="balances-modal-header d-flex align-items-center justify-content-between">
          <h5 class="mb-0">{{ $t('header.otherBalances') }}</h5>
          <button class="bg-transparent border-0 lh-1" @click="closeBalancesModal">
            <i class="ph-bold ph-x fs-4"></i>
          </button>
        </div>
        <div class="balances-modal-body">
          <div class="balance-row d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="icon text-danger rounded-circle text-center balance-icon-sm" style="border:1px solid red;">
                <i class="ph-duotone ph-shield-plus"></i>
              </div>
              <span class="ms-10">{{ $t('header.availableBalance') }}</span>
            </div>
            <strong>{{ balance }} XOF</strong>
          </div>

          <div class="balance-row d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="icon text-success rounded-circle text-center balance-icon-sm" style="border:1px solid green;">
                <i class="flaticon-money"></i>
              </div>
              <span class="ms-10">{{ $t('header.collectBalance') }}</span>
            </div>
            <strong>{{ collect }} XOF</strong>
          </div>

          <div class="balance-row d-flex justify-content-between align-items-center">
            <div class="d-flex align-items-center">
              <div class="icon text-primary rounded-circle text-center balance-icon-sm" style="border:1px solid blueviolet;">
                <i class="flaticon-money"></i>
              </div>
              <span class="ms-10">{{ $t('header.transferBalance') }}</span>
            </div>
            <strong>{{ transfert }} XOF</strong>
          </div>
        </div>
      </div>
    </div>
  </teleport>
</template>

<script lang="ts" setup>
import { ref, onMounted, inject, computed, onUpdated, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import stateStore from "../../utils/store";
import { formatNumber, checkSessionValidate } from "../../utils/function";
import axios from 'axios';
import router from '../../router/index'

const backApi = inject('back');
const { t } = useI18n();

const isSticky = ref(false);

const refreshKey = ref(0);

const userRole = computed(() => {
  refreshKey.value;
  return localStorage.getItem('role') || '';
});
const userToken = computed(() => {
  refreshKey.value;
  return localStorage.getItem('login_token') || '';
});
const organizationCode = computed(() => {
  refreshKey.value;
  return localStorage.getItem('organization_code') || '';
});
const userCode = computed(() => {
  refreshKey.value;
  return localStorage.getItem('code') || '';
});
const organizationName = computed(() => {
  refreshKey.value;
  return localStorage.getItem('organization_name') || '';
});
const userName = computed(() => {
  refreshKey.value;
  return localStorage.getItem('name') || '';
});
const userEmail = computed(() => {
  refreshKey.value;
  return localStorage.getItem('email') || '';
});
const accountSize = computed(() => {
  refreshKey.value;
  return parseFloat(localStorage.getItem('account_size') || '0');
});
const personalAccountStatus = computed(() => {
  refreshKey.value;
  return localStorage.getItem('personnal_account_status') || '';
});

// === ÉTATS RÉACTIFS POUR LES SOLDES ===
const balance = ref('0');
const collect = ref('0');
const transfert = ref('0');
const mainBalance = ref('0');



const showBalancesModal = ref(false);

const toggleBalancesModal = () => {
  showBalancesModal.value = !showBalancesModal.value;
};

const closeBalancesModal = () => {
  showBalancesModal.value = false;
};

const stateStoreInstance = computed(() => stateStore);

function formatDateEn(value: Date, d = 0) {
  if (value) {
    const year = value.getFullYear();
    let month = value.getMonth() + 1;
    month = month < 10 ? '0' + month : month;
    let day = value.getDate() + d;
    day = day < 10 ? '0' + day : day;
    return year + '-' + month + '-' + day;
  }
}

function getFile() {
  window.open(`/izypay.pdf`, "_blank");
}

// === FONCTIONS DE RÉCUPÉRATION DES SOLDES ===
const getBalanceAvailable = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/available', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    balance.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getCollectBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/collect', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    collect.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getTransfertBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/payout', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    transfert.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getTransfertBalancePerso = () => {
  const token = userToken.value;
  const code = userCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/main', {
    user: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    transfert.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const getMainBalance = () => {
  const token = userToken.value;
  const code = organizationCode.value;
  if (!token || !code || userRole.value === "SUPERADMIN") return;

  axios.post(backApi + '/secure/accounts/balance/main', {
    organization: code,
  }, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })
  .then((response) => {
    mainBalance.value = formatNumber(parseInt(response.data.balance));
  }).catch((error) => {
    if (error.response) {
      console.log(error.response.data);
      if (error.response.status === 401) {
        handleLogout();
      }
    }
  });
}

const handleLogout = () => {
  localStorage.clear();
  window.dispatchEvent(new CustomEvent('user-logout'));
  window.dispatchEvent(new Event('storage'));
  router.push('/');
};

const loadAllData = () => {
  const token = userToken.value;
  if (!token) {
    balance.value = '0';
    collect.value = '0';
    transfert.value = '0';
    mainBalance.value = '0';
    return;
  }

  if (userRole.value === "SUPERADMIN") {
    balance.value = '0';
    collect.value = '0';
    transfert.value = '0';
    mainBalance.value = '0';
    return;
  }

  if (checkSessionValidate()) {
    getBalanceAvailable();
    getCollectBalance();
    getMainBalance();
    if (accountSize.value > 0 && personalAccountStatus.value === "ACTIVE") {
      getTransfertBalancePerso();
    } else {
      getTransfertBalance();
    }
  }
};

let intervalId: number | null = null;

const startInterval = () => {
  if (intervalId) {
    clearInterval(intervalId);
  }

  intervalId = setInterval(() => {
    if (localStorage.getItem('login_token') !== null) {
      if (checkSessionValidate() && userRole.value !== "SUPERADMIN") {
        getBalanceAvailable();
        getCollectBalance();
        getMainBalance();
        if (accountSize.value > 0 && personalAccountStatus.value === "ACTIVE") {
          getTransfertBalancePerso();
        } else {
          getTransfertBalance();
        }
      }
    }
  }, 30000);
};

const onUserLogin = () => {
  refreshKey.value++;
  loadAllData();
};

const onUserLogout = () => {
  refreshKey.value++;
  balance.value = '0';
  collect.value = '0';
  transfert.value = '0';
  mainBalance.value = '0';
  showBalancesModal.value = false;
};

const onStorageChange = (e: StorageEvent) => {
  if (e.key === 'login_token' || e.key === 'role' || e.key === 'organization_code') {
    refreshKey.value++;
    loadAllData();
  }
};

const onScroll = () => {
  let scrollPos = window.scrollY;
  isSticky.value = scrollPos >= 100;
};

// === CYCLE DE VIE ===
onMounted(() => {
  loadAllData();
  startInterval();

  window.addEventListener('user-login', onUserLogin);
  window.addEventListener('user-logout', onUserLogout);
  window.addEventListener('storage', onStorageChange);
  window.addEventListener('scroll', onScroll);
});

onUpdated(() => {
  const currentToken = localStorage.getItem('login_token');
  if (currentToken && currentToken !== userToken.value) {
    refreshKey.value++;
    loadAllData();
  }
});

onUnmounted(() => {
  if (intervalId) {
    clearInterval(intervalId);
  }
  window.removeEventListener('user-login', onUserLogin);
  window.removeEventListener('user-logout', onUserLogout);
  window.removeEventListener('storage', onStorageChange);
  window.removeEventListener('scroll', onScroll);
});
</script>

<style scoped>
.invisible {
  visibility: hidden;
  display: none;
}

.balance-label {
  display: none;
}
@media (min-width: 992px) {
  .balance-label {
    display: block;
  }
}

.balance-title {
  display: flex;
  align-items: center;
}
@media (min-width: 992px) {
  .balance-title {
    display: block;
  }
}

.header-left-side .header-burger-menu {
  padding: 0 6px;
}
.header-left-side .header-burger-menu i {
  font-size: 18px;
}
@media (min-width: 992px) {
  .header-left-side .header-burger-menu {
    padding: 0 10px;
  }
  .header-left-side .header-burger-menu i {
    font-size: 22px;
  }
}

.balance-icon {
  height: 40px;
  width: 40px;
  min-width: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.balance-title {
  display: block;
  text-align: left;
  font-size: 11px;
  line-height: 1.2;
}

.balance-item {
  margin: 4px 8px;
  flex-shrink: 0;
}

.header-right-side {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: flex-end;
  overflow-x: auto;
  overflow-y: hidden;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.header-right-side::-webkit-scrollbar {
  display: none;
}

.balances-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1050;
  padding: 16px;
}
.balances-modal-content {
  background: #fff;
  border-radius: 12px;
  width: 100%;
  max-width: 380px;
  padding: 20px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.2);
}
.balances-modal-header {
  margin-bottom: 16px;
}
.balances-modal-body {
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.balance-row {
  padding: 8px 0;
  border-bottom: 1px solid #f0f0f0;
}
.balance-row:last-child {
  border-bottom: none;
}
.balance-icon-sm {
  height: 30px;
  width: 30px;
  min-width: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
}


.balance-chevron {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  margin-top: 25px;
  min-width: 22px;
  border-radius: 50%;
  background: rgba(124, 58, 237, 0.1);
  color: #7c3aed;
  transition: transform 0.25s ease, background 0.25s ease;
}
.balance-chevron i {
  font-size: 12px;
  line-height: 1;
}
.balance-chevron.is-open {
  background: rgba(124, 58, 237, 0.2);
  transform: rotate(180deg);
}

@media (max-width: 991.98px) {
  .balance-chevron {
    width: 16px;
    height: 16px;
    min-width: 16px;
  }
  .balance-chevron i {
    font-size: 9px;
  }
}

/* ===== User info ===== */
.user-info {
  max-width: 160px;
  overflow: hidden;
}
.user-info .text-truncate {
  max-width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

@media (min-width: 992px) {
  .balance-icon {
    height: 50px;
    width: 50px;
    min-width: 50px;
  }
  .balance-title {
    font-size: 13px;
  }
  .user-info {
    max-width: 220px;
  }
  .header-right-side {
    flex-wrap: wrap;
    overflow-x: visible;
    overflow-y: visible;
  }
}

@media (max-width: 991.98px) {
  .header-area > .row {
    flex-wrap: nowrap !important;
  }

  .header-area .col-md-6:first-child {
    flex: 0 0 auto !important;
    width: auto !important;
    max-width: none !important;
  }
  .header-area .col-md-6:last-child {
    flex: 1 1 auto !important;
    width: auto !important;
    max-width: none !important;
  }

  .header-right-side {
    justify-content: flex-end !important;
    flex-wrap: nowrap !important;
    overflow-x: auto;
  }

  .balance-icon {
    height: 28px !important;
    width: 28px !important;
    min-width: 28px !important;
  }
  .balance-icon i {
    font-size: 14px !important;
  }
  .balance-title {
    font-size: 8px !important;
    margin-left: 4px !important;
  }
  .balance-item {
    margin: 2px 4px !important;
    flex-shrink: 1;
    min-width: 0;
  }
  .balance-label {
    display: none !important;
  }

  .user-info {
    max-width: 100px !important;
  }
  .profile-dropdown img {
    width: 30px !important;
    height: 30px !important;
  }

  .header-area {
    padding-left: 8px !important;
    padding-right: 8px !important;
  }
}

@media (max-width: 480px) {
  .balance-icon {
    height: 24px !important;
    width: 24px !important;
    min-width: 24px !important;
  }
  .balance-icon i {
    font-size: 12px !important;
  }
  .balance-title {
    font-size: 7px !important;
    margin-left: 3px !important;
  }
  .balance-item {
    margin: 2px 3px !important;
  }
  .user-info {
    max-width: 70px !important;
  }
  
  .profile-dropdown img {
    width: 26px !important;
    height: 26px !important;
  }
}

@media screen and (min-width: 992px) and (max-width: 1366px) {
  .header-area {
    padding-left: 10px !important;
    padding-right: 10px !important;
  }
  .balance-icon {
    height: 36px !important;
    width: 36px !important;
    min-width: 36px !important;
  }
  .balance-icon i {
    font-size: 16px !important;
  }
  .balance-title {
    font-size: 10px !important;
    margin-left: 6px !important;
  }
  .balance-item {
    margin: 4px 4px !important;
  }
  .balance-label {
    display: none !important;
  }
  .user-info {
    max-width: 140px !important;
  }
  .profile-dropdown img {
    width: 36px !important;
    height: 36px !important;
  }
}
</style>